<template>
  <div class="content pr-2">
    <!--<h1 class="subtitle is-3 has-text-centered">AHL Rules & Regulations</h1>-->
    <div class="tabs is-toggle is-fullwidth">
      <ul>
        <tab
            v-for="tab in tabs"
            :key="tab.id"
            :tab-title="tab"
            :active-tab="activeTab"
            @switchActiveTab="switchActiveTab"
        />
      </ul>
    </div>
    <component :is="activeTab" :rulesHtml="rulesHtml"/>
  </div>
</template>

<script>
import Tab from '../home/Tab.vue'
import TournamentPoints from './Points.vue'
import AhlPrizesAndEvents from './Prizes.vue'
import TournamentStructure from './Structure.vue'
import OfficialAhlTournamentRules from './TournamentRules.vue'

export default {
  name: 'Rules',
  metaInfo: {
    title: 'AHL Poker :: Rules'
  },
  components: {
    Tab,
    TournamentPoints,
    AhlPrizesAndEvents,
    TournamentStructure,
    OfficialAhlTournamentRules
  },
  computed: {
    rulesHtml() {
      if (this.activeTab && this.rulesData) {
        return this.rulesData[this.activeTab.replace(/-/g,"").toUpperCase()];
      }
    }
  },
  data() {
    return {
      rulesData: {},
      tabs: [
        'ahl prizes and events',
        'official ahl tournament rules',
        'tournament points',
        'tournament structure'
      ],
      activeTab: ''
    }
  },
  mounted() {
    this.getRules();
  },
  methods: {
    getRules() {
      this.$axios({
        method: 'POST',
        url: 'general/getrules',
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token
        }
      }).then((res) => {
        this.rulesData = res.data;
        let initialTab = this.tabs[1].split(' ').join('-')
        this.activeTab = initialTab
      }).catch((error) => {
        this.$emit('message', {error: true, showDialog: true, message: error.response.data.message});
      });
    },
    switchActiveTab(tabTitle) {
      this.activeTab = tabTitle
    }
  }
}
</script>